/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type CurrentWatchers_watchers$ref: FragmentReference;
declare export opaque type CurrentWatchers_watchers$fragmentType: CurrentWatchers_watchers$ref;
export type CurrentWatchers_watchers = $ReadOnlyArray<{|
  +id: any,
  +isOwner: ?boolean,
  +knownUser: ?{|
    +id: string,
    +firstName: string,
    +lastName: string,
    +title: ?string,
  |},
  +$refType: CurrentWatchers_watchers$ref,
|}>;
export type CurrentWatchers_watchers$data = CurrentWatchers_watchers;
export type CurrentWatchers_watchers$key = $ReadOnlyArray<{
  +$data?: CurrentWatchers_watchers$data,
  +$fragmentRefs: CurrentWatchers_watchers$ref,
  ...
}>;
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "CurrentWatchers_watchers",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "KnownUser",
      "kind": "LinkedField",
      "name": "knownUser",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BarrierWatcher",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '8201c1ba22c22848c183e324f116be7e';

module.exports = node;
